/* eslint-disable @typescript-eslint/no-explicit-any */
import { imageDomain, imageDomainCN } from '../../modules/utils/constants';
import { checkChinaLocale, prependDomainIfMissing } from '../../modules/utils/helper';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const mapper = require('object-mapper');

const getRoot = (r: any) => (r?.data ? r.data : r);

const dedupeByUrl = (arr: Array<{ url: string }>) => {
  const seen = new Set<string>();
  return arr.filter(x => (x?.url && !seen.has(x.url) ? (seen.add(x.url), true) : false));
};

const selectImages = (mediaUnion: any, locale: string) => {
  if (!mediaUnion) return [];
  // MBOP first
  if (mediaUnion?.loyaltyOffers) {
    const los = Array.isArray(mediaUnion.loyaltyOffers) ? mediaUnion.loyaltyOffers : [mediaUnion.loyaltyOffers];
    const out: any[] = [];
    for (const lo of los) {
      const imgs = Array.isArray(lo?.imageData) ? lo.imageData : lo?.imageData ? [lo.imageData] : [];
      for (const d of imgs) {
        const urlBase = checkChinaLocale(locale) ? imageDomainCN : imageDomain;
        const alt = d?.alternateDescription;
        const s = prependDomainIfMissing(d?.imageUrls?.square, urlBase),
          f = prependDomainIfMissing(d?.imageUrls?.featureHorizontal, urlBase);
        if (s) out.push({ altImageUrl: null, alternateText: alt, url: String(s), __typename: 'PromotionMediaImage' });
        if (f) out.push({ altImageUrl: null, alternateText: alt, url: String(f), __typename: 'PromotionMediaImage' });
        if (out.length >= 2) return dedupeByUrl(out).slice(0, 2);
      }
    }
    return dedupeByUrl(out).slice(0, 2);
  }
  // CTS fallback
  const imgs = Array.isArray(mediaUnion?.images) ? mediaUnion.images : [];
  return imgs
    .filter((i: any) => !!i?.url)
    .map((i: any) => ({
      altImageUrl: i?.altImageUrl ?? null,
      alternateText: i?.alternateText ?? '',
      url: String(i?.url),
      __typename: 'PromotionMediaImage',
    }));
};

const toLegacyPromotionDetail = (promotionById: any, root: any, locale: string) => {
  if (!promotionById || typeof promotionById !== 'object') return null;

  const node = getRoot(root)?.marketing?.promotions?.promotionById || promotionById;
  const promoId = node?.id ?? null;
  const headlineName = node?.descriptions?.name ?? null;
  const images = selectImages(node?.media, locale);

  // Offer descriptions index & ordered ids
  const ods = Array.isArray(node?.offersDescriptions) ? node.offersDescriptions : [];
  const offerIds = ods.map((r: any) => String(r?.id || '').split('.')[0]).filter(Boolean);
  const descIndex = ods.reduce((acc: Record<string, any[]>, r: any) => {
    const key = String(r?.id || '').split('.')[0];
    if (key) acc[key] = (r?.descriptions ?? []).map((d: any) => ({ key: d?.key, value: d?.value }));
    return acc;
  }, {});

  const offers = offerIds.map((offerId: string) => ({
    descriptions: {
      promotionId: promoId,
      offerId,
      name: null,
      descriptions: descIndex[offerId] || [],
      __typename: 'PromotionOfferDescriptions',
    },
    id: offerId,
    __typename: 'PromotionOffer',
  }));

  return {
    id: promoId,
    name: headlineName ?? null,
    descriptions: { name: headlineName, __typename: 'PromotionDescriptions' },
    media: { images, __typename: 'PromotionMedia' },
    offers,
    __typename: 'Promotion',
  };
};

const promotionByIdTemplate = (locale: string) => ({
  'marketing?.promotions?.promotionById': {
    key: 'data?.promotion',
    transform: (promotionById: any, root: any) => toLegacyPromotionDetail(promotionById, root, locale),
  },
});

export const mapPromotionByIdToLegacy = (response: any, locale: string) =>
  mapper(getRoot(response), promotionByIdTemplate(locale));
